import React from 'react';

interface list<T> {
  navItems: { opt: T; id: string }[];
  focusedOptionId: string | null;
}

interface keyboardActions {
  arrowKey: (optionId: string | null) => void;
  enter: (optionId: string | null) => void;
}

/**
 * @deprecated
 */
export function listNav<T>(
  list: list<T>,
  actions: keyboardActions,
): (e: React.KeyboardEvent) => void {
  return (e: React.KeyboardEvent) => {
    let index: number;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (list.navItems.length > 0) {
          let nextNavItem: { opt: T; id: string } | undefined;
          if (!list.focusedOptionId) {
            nextNavItem = list.navItems[0];
          } else {
            index = list.navItems.findIndex(({ id }) => id == list.focusedOptionId) + 1;
            if (index >= list.navItems.length) {
              index = 0;
            }
            nextNavItem = list.navItems[index];
          }
          if (nextNavItem) {
            actions.arrowKey(nextNavItem.id);
          }
        }

        break;
      case 'ArrowUp':
        e.preventDefault();
        if (list.navItems.length > 0) {
          let nextNavItem: { opt: T; id: string } | undefined;
          if (!list.focusedOptionId) {
            nextNavItem = list.navItems[list.navItems.length - 1];
          } else {
            index = list.navItems.findIndex(({ id }) => id == list.focusedOptionId) - 1;
            if (index < 0) {
              index = list.navItems.length - 1;
            }
            nextNavItem = list.navItems[index];
          }
          if (nextNavItem) {
            actions.arrowKey(nextNavItem.id);
          }
        }

        break;
      case 'Enter':
        actions.enter(list.focusedOptionId);
        break;
    }
  };
}
